package com.parmartechnologies.core.extension

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
actual fun UniqueueID(): String {
    return Uuid.toString()
}